if (!window.Maximize.loadedScript.includes('product-matching-addons.js')) {
  window.Maximize.loadedScript.push('product-matching-addons.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xMatchingAddons', (config) => ({
        moneyFormat: config.moneyFormat || '',
        mainVariantId: Number(config.mainVariantId) || 0,
        mainPrice: Number(config.mainPrice) || 0,
        mainAvailable: config.mainAvailable !== false,
        mainProductSectionId: config.mainProductSectionId || null,
        addons: config.addons || [],
        // Line item property used by the theme's product form for back-ordered
        // (pre-order) variants, e.g. "Précommande": "Expédié sous 4 à 8 semaines".
        preorderPropName: config.preorderPropName || '',
        preorderMessage: config.preorderMessage || '',

        // Array of selected addon keys — more reliable than a keyed object
        selectedKeys: [],
        isLoading: false,
        errorMessage: '',
        totalPriceFormatted: '',
        mainQty: 1,
        addonQtys: {},

        init() {
          this.selectedKeys = [];
          const qtys = {};
          (this.addons || []).forEach((a) => { qtys[a.key] = 1; });
          this.addonQtys = qtys;
          this.updateTotal();
          this.__trackMainQty();
          this.__syncMainQty();

          // Auto-detect main product section for variant-change events
          if (!this.mainProductSectionId) {
            const el = document.querySelector('main-product');
            if (el && el.dataset.sectionId) {
              this.mainProductSectionId = el.dataset.sectionId;
            }
          }
          if (this.mainProductSectionId) {
            this.__listenVariantChange();
            this.__interceptAddToCart();
          }
        },

        __listenVariantChange() {
          const eventName = `maximize:variant-picker:updated:${this.mainProductSectionId}`;
          document.addEventListener(eventName, (event) => {
            const v = (event.detail || {}).currentVariant;
            if (!v) return;
            this.mainVariantId = Number(v.id) || 0;
            this.mainPrice = Number(v.price) || 0;
            this.mainAvailable = v.available !== false;
            this.updateTotal();
            // The theme resets the quantity selector to 1 on variant change,
            // but writes the value programmatically — re-read it after that.
            setTimeout(() => this.__syncMainQty(), 0);
          });
        },

        __readMainQtyInput() {
          const mainProduct = document.querySelector('main-product');
          if (!mainProduct) return null;
          return mainProduct.querySelector('[name="quantity"]');
        },

        __syncMainQty() {
          const input = this.__readMainQtyInput();
          const qty = input ? Number(input.value) || 1 : 1;
          if (qty !== this.mainQty) {
            this.mainQty = qty;
            this.updateTotal();
          }
        },

        __trackMainQty() {
          const mainProduct = document.querySelector('main-product');
          if (!mainProduct || mainProduct._addonsQtyTracked) return;
          mainProduct._addonsQtyTracked = true;
          // Direct typing in the quantity input
          mainProduct.addEventListener('input', (e) => {
            if (e.target && e.target.name === 'quantity') this.__syncMainQty();
          });
          mainProduct.addEventListener('change', (e) => {
            if (e.target && e.target.name === 'quantity') this.__syncMainQty();
          });
          // The +/- buttons update the input programmatically (no input event),
          // so re-read the value right after any click inside the selector.
          mainProduct.addEventListener('click', (e) => {
            if (e.target.closest('[name="plus"], [name="minus"]')) {
              setTimeout(() => this.__syncMainQty(), 0);
            }
          });
        },

        isSelected(key) {
          return this.selectedKeys.includes(key);
        },

        selectedCount() {
          return this.selectedKeys.length;
        },

        __interceptAddToCart() {
          // Strategy: intercept at the document level during capture phase so our
          // handler runs BEFORE Alpine's @click.prevent="handleAddToCart()" on the
          // button. When addons are selected we call stopPropagation() so Alpine
          // never receives the click, then we send ONE combined cart/add.js request
          // (main product + all selected addons). This avoids any race conditions
          // or duplicate-add bugs caused by event-chaining.
          const mainProduct = document.querySelector('main-product');
          if (!mainProduct || mainProduct._addonsIntercepted) return;
          mainProduct._addonsIntercepted = true;

          document.addEventListener('click', (e) => {
            // Only act on the native add-to-cart button
            if (!e.target.closest('.product-form__btn-add-to-cart')) return;
            // If no addons selected let Alpine handle normally
            if (this.selectedKeys.length === 0) return;
            // stopPropagation prevents the event from reaching the button (so
            // Alpine's @click.prevent="handleAddToCart()" never fires).
            // preventDefault prevents the browser's own default action for a
            // submit-button click (native form POST → 302 redirect to /cart).
            e.stopPropagation();
            e.preventDefault();

            // Read variant id + quantity from the product form
            const form =
              mainProduct.querySelector('[x-ref="product_form"]') ||
              mainProduct.querySelector('form[data-type="add-to-cart-form"]');
            const variantId = form
              ? Number(form.querySelector('[name="id"]')?.value) || this.mainVariantId
              : this.mainVariantId;
            const qty = form
              ? Number(form.querySelector('[name="quantity"]')?.value) || 1
              : 1;

            if (!variantId) return;

            // Build unified items list: main product first, then selected addons.
            // The main product keeps the line item properties its own form would
            // have sent (pre-order note, estimated delivery, etc.).
            const mainItem = { id: variantId, quantity: qty };
            const mainProps = this.__formProperties(form);
            if (Object.keys(mainProps).length) mainItem.properties = mainProps;
            const items = [mainItem];
            this.addons.forEach((a) => {
              const varId = Number(a.variantId);
              if (this.selectedKeys.includes(a.key) && a.available && varId > 0) {
                items.push(this.__addonItem(a));
              }
            });

            this.isLoading = true;
            this.__addToCart(items).finally(() => {
              this.isLoading = false;
            });
          }, { capture: true });
        },

        toggle(key) {
          const idx = this.selectedKeys.indexOf(key);
          if (idx === -1) {
            this.selectedKeys.push(key);
            this.addonQtys[key] = this.addonQtys[key] || 1;
          } else {
            this.selectedKeys.splice(idx, 1);
            this.addonQtys[key] = 1;
          }
          this.updateTotal();
        },

        qtyOf(key) {
          return this.addonQtys[key] || 1;
        },

        incQty(key) {
          this.addonQtys[key] = (this.addonQtys[key] || 1) + 1;
          this.updateTotal();
        },

        decQty(key) {
          this.addonQtys[key] = Math.max(1, (this.addonQtys[key] || 1) - 1);
          this.updateTotal();
        },

        updateTotal() {
          let total = this.mainAvailable ? this.mainPrice * (this.mainQty || 1) : 0;
          this.addons.forEach((a) => {
            if (this.selectedKeys.includes(a.key) && a.available) {
              total += (Number(a.price) || 0) * (this.addonQtys[a.key] || 1);
            }
          });
          this.totalPriceFormatted =
            typeof formatMoney === 'function'
              ? formatMoney(total, this.moneyFormat)
              : total;
        },

        async addSelected() {
          if (this.isLoading) return;
          const items = [];

          // Main product is always "Inclus"
          if (this.mainVariantId && this.mainAvailable) {
            const mainItem = { id: this.mainVariantId, quantity: 1 };
            const mainProps = this.__formProperties(this.__mainForm());
            if (Object.keys(mainProps).length) mainItem.properties = mainProps;
            items.push(mainItem);
          }

          // Selected addons
          this.addons.forEach((a) => {
            const key = a.key;
            const varId = Number(a.variantId);
            if (this.selectedKeys.includes(key) && a.available && varId > 0) {
              items.push(this.__addonItem(a));
            }
          });

          if (!items.length) {
            this.errorMessage = 'Veuillez sélectionner au moins un article.';
            setTimeout(() => (this.errorMessage = ''), 4000);
            return;
          }

          this.isLoading = true;
          await this.__addToCart(items);
          this.isLoading = false;
        },

        __mainForm() {
          const mainProduct = document.querySelector('main-product');
          if (!mainProduct) return null;
          return (
            mainProduct.querySelector('[x-ref="product_form"]') ||
            mainProduct.querySelector('form[data-type="add-to-cart-form"]')
          );
        },

        // Collect properties[...] inputs from the main product form (disabled
        // inputs are skipped by FormData, matching what a normal submit sends).
        __formProperties(form) {
          const props = {};
          if (!form) return props;
          try {
            new FormData(form).forEach((val, name) => {
              const m = name.match(/^properties\[(.+)\]$/);
              if (m && typeof val === 'string' && val.trim() !== '') {
                props[m[1]] = val;
              }
            });
          } catch (e) {
            /* ignore */
          }
          return props;
        },

        // Cart line for an addon; back-ordered addons get the same pre-order
        // property the theme adds when the product is bought from its own page.
        __addonItem(a) {
          const item = { id: Number(a.variantId), quantity: this.addonQtys[a.key] || 1 };
          // Per-product message (metafield custom.delai_livraison via snippets/preorder-message.liquid)
          // falls back to the global settings.message_preorder_cart text.
          const preorderMessage = a.preorderMessage || this.preorderMessage;
          if (a.preorder && this.preorderPropName && preorderMessage) {
            item.properties = { [this.preorderPropName]: preorderMessage };
          }
          return item;
        },

        async __addToCart(items) {
          if (!items.length) return;
          this.errorMessage = '';

          let cartSectionElement = document.querySelector('#CartDrawer');
          let cartSectionElementId =
            cartSectionElement && cartSectionElement.dataset.sectionId
              ? cartSectionElement.dataset.sectionId
              : false;
          if (window.Maximize && window.Maximize.isCartPage) {
            cartSectionElement = document.querySelector('#MainCart__Items');
            cartSectionElementId =
              cartSectionElement && cartSectionElement.dataset.sectionId;
          }
          const sectionsToRender =
            Alpine.store('xCartHelper').getSectionsToRender(cartSectionElementId);

          try {
            const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items,
                sections: sectionsToRender.map((s) => s.id),
              }),
            });
            const data = await res.json();

            if (data.status === 422 || data.status === '422') {
              this.errorMessage = data.description || 'Impossible d\'ajouter au panier.';
              setTimeout(() => (this.errorMessage = ''), 5000);
              if (Alpine.store('xMiniCart')) Alpine.store('xMiniCart').reLoad();
              return;
            }

            if (data.sections) {
              sectionsToRender.forEach((section) => {
                const el = document.querySelector(section.selector);
                if (el && data.sections[section.id]) {
                  el.innerHTML = getSectionInnerHTML(
                    data.sections[section.id],
                    section.selector
                  );
                }
              });
            }

            if (Alpine.store('xMiniCart')) Alpine.store('xMiniCart').handleOpen();
            Alpine.store('xCartHelper').updateCurrentCountItem();
            document.dispatchEvent(
              new CustomEvent('maximize:cart:updated', {
                bubbles: true,
                detail: { isItemCountChanged: true },
              })
            );
          } catch (err) {
            console.error('[matching-addons] cart error:', err);
            this.errorMessage = 'Erreur réseau. Veuillez réessayer.';
            setTimeout(() => (this.errorMessage = ''), 5000);
          }
        },
      }));
    });
  });
}
